import { ButtonColor } from "../buttons/ButtonColor";
import { ButtonInterface } from "../buttons/ButtonInterface";
import { MenuItemBasic } from "./MenuItemBasic";

export class MenuItemColor extends MenuItemBasic {
  constructor(
    protected override name: string,
    protected override mesh,
    protected override parentMesh,
    protected override type: string,
    protected override button: ButtonInterface = null,
    protected override items: MenuItemBasic[] = [],
    protected targets,
    protected colors
  ) {
    super(
      name,
      mesh,
      parentMesh,
      type,
      button,
      items
    );
    this.targets = targets;
    this.colors = colors;
    // this.button = new ButtonColor(name, color, false, clickable, false, false);
  }

}
